module.exports = __webpack_public_path__ + "img/system4.586ec9fb.png";